productHandler = {
    $btnAddToCartProduct : $('#btn-add-to-cart'),
    $addToCartMessage    : $('.add-to-cart-message'),
    $addValBtn           : $('.add-val-btn'),
    $removeValBtn        : $('.remove-val-btn'),
    $productCount        : $('.product-count'),
    $wcCartForm          : $('.woocommerce-cart-form'),
    isLoad               : false,

    addToCart: function(){
        let self = this;

        this.$btnAddToCartProduct.on('click', function(e){
            let $self  = $(this);
            let id     = $(this).data('product-id');
            let type   = $(this).data('type');
            let href   = $(this).attr('href');
            
            if (href == '#') {
                e.preventDefault();
                
                if (!self.isLoad) {
                    $.ajax({
                        type: 'POST',
                        url: myAjax.ajax_url,
                        data: {
                            action: 'add_to_cart',
                            id: id,
                            type: type
                        },
                        
                        beforeSend: function() {
                            self.isLoad = true;
                            // self.$btnAddToCartProduct.addClass('icon icon-loading');
                        },
            
                        success: function(response) {
                            self.$addToCartMessage.html(response['message']);
                            self.$productCount.html(response['cart_items']);
                            self.isLoad = false;
                            $self.attr('href', '/cart');
                            $self.html('View Cart');
                            // self.$btnAddToCartProduct.removeClass('icon icon-loading');
                        }
                    });
                }
            }
        })
    },

    wcCartEvents: function(){
        let self = this;
        
        $( document ).on('click', '.add-val-btn', function(){
            let $input = $(this).next().find('input');
            let num = parseInt($input.val()) + 1;
            $input.val(num).change();
        });

        $( document ).on('click', '.remove-val-btn', function(){
            let $input = $(this).prev().find('input');
            let num = parseInt($input.val()) - 1;
            num = num < 1 ? 1 : num;
            $input.val(num).change();
        });

        $( document ).on( 'added_to_cart removed_from_cart' , function(){
            self.updateCartCount();
        });

        $( document ).on( 'updated_cart_totals', function(){
            self.wcSetSelectUI();
            self.updateCartCount()
        });
    },

    updateCartCount: function(){
        let self = this;
        if (!self.isLoad) {
            $.ajax({
                type: 'POST',
                url: myAjax.ajax_url,
                data: {action: 'get_cart_item_count'},
                
                beforeSend: function() {
                    self.isLoad = true;
                },
    
                success: function(response) {
                    self.$productCount.html(response['cart_items']);
                    self.isLoad = false;                    
                }
            });
        }        
    },

    wcSetSelectUI: function($obj=null){
        let $wcSelect = ($obj == null) ? $('.woocommerce select') : $obj.find('.woocommerce select'); 
        $wcSelect.each(function(){
            let val   = $(this).val();
            let $this = $(this); 
           
            // special treatment for bug state didnt selected after clicking calculate
            if ($this.hasClass('state_select')) {
                $this = $('#calc_shipping_state');   
            }

            $this.val('').trigger('change');
            $this.val(val).trigger('change');
        })        
    },

    init: function(){
        var self = this;

        this.addToCart();
        this.wcCartEvents();

    }
}